import React from 'react'
import classes from "./styles/layout.module.css";
import Navbar from './Navbar';
import Footer from './Footer';
import styles from './styles/button.module.css';
import { useNavigate } from 'react-router-dom';

const Layout = ({ children }) => {
  const navigate = useNavigate();

  const initiateWhatsAppChat = () => {
    const phoneNumber = "+917389940354"; // Your WhatsApp number
    const message = `Hi! I'm interested in Online Fitness & Nutrition batches. Please can you share the details!`;
    const whatsappURL = `https://wa.me/${phoneNumber.replace(/\D/g, "")}?text=${encodeURIComponent(message)}`;
    window.open(whatsappURL, "_blank"); // Opens the WhatsApp link in a new tab
  };

  const scrollToContact = () => {
    const element = document.getElementById("DiscoveryCallSection");
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }else{
      navigate("/");
      const delayImport = () => {
        const element2 = document.getElementById("DiscoveryCallSection");
        element2.scrollIntoView({ behavior: 'smooth' });
      };
      const timeoutId = setTimeout(() => {
        delayImport();
      }, 300);
      return () => clearTimeout(timeoutId);
    }
  };

    return (
      <>
        <div className={classes.navbar}>
        <Navbar />
        </div>
        <div className={classes.pages}>
            {children}
            <div className={classes.whatsappCon} onClick={initiateWhatsAppChat}>
              <img src='https://cdn-icons-png.flaticon.com/128/1384/1384055.png' alt='whatsapp'/>
            </div>
            <button className={`${styles.button}`} onClick={scrollToContact}>Book a Call</button>
        </div>
        <Footer />
      </>
    );
  };

export default Layout;